// @ vendor
const React = require('react');
const PropTypes = require('prop-types');


const AnotherEstatesInputMinusPlus = (props) => {
    const { config, onHandleBtnClick } = props;


    const btnMinus = config.showBtns ?
        (<button onClick={() => onHandleBtnClick(config.type, '-')} className="mortgage-request-estates-view__button">
            <i className="glyphicon ok-input__label mortgage-request-estates-view__icon glyphicon-minus"></i>
        </button>) :
        '';

    const btnPlus = config.showBtns ?
        (<button onClick={() => onHandleBtnClick(config.type, '+')} className="mortgage-request-estates-view__button">
            <i className="glyphicon ok-input__label mortgage-request-estates-view__icon glyphicon-plus"></i>
        </button>) :
        '';

    return (
        <div className="col-xs-4 ok-input text-center">
            <label className="ok-input__label mortgage-request-estates-view__label" >{config.label}</label>
            {btnMinus}
            <input
                id={`${config.type}Input`}
                type="text"
                className="mortgage-request-estates-view__input"
                readOnly
                value={config.value}
            />
            {btnPlus}
        </div>
    );
}

AnotherEstatesInputMinusPlus.propTypes = {
    config: PropTypes.object.isRequired,
    onHandleBtnClick: PropTypes.func.isRequired,
};

module.exports = AnotherEstatesInputMinusPlus;